import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from 'types';
import { syncRenderLogging, stopRenderLogging } from './renderLogger';

/**
 * Keeps the render log hooked to whichever viewers currently exist.
 *
 * `docManager.fileIds` is the signal: `loadWebViewer` writes a fileId the moment a viewer instance
 * is ready and `unloadViewers` clears it on unmount, so reacting to it catches every viewer coming
 * and going without polling for one.
 */
const useRenderLogging = () => {
  const fileIds = useSelector((state: StoreState) => state.docManager.fileIds);

  useEffect(() => {
    syncRenderLogging();
  }, [fileIds]);

  useEffect(() => stopRenderLogging, []);
};

export default useRenderLogging;
